/* popover-surface.tsx generated by @compiled/babel-plugin v3.0.2 */
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._0bjKvD8fU6%7Bborder-radius%3Avar(--ds-radius-large%2C8px)%7D%0A._4bt5LAIZbP%7Boverflow-x%3Aauto%7D%0A._2WAcuGIZbP%7Boverflow-y%3Aauto%7D%0A._0KLXruoI2d%7Bbackground-color%3Avar(--ds-surface-overlay%2C%23fff)%7D%0A._1UtDYzy7kJ%7Bcolor%3Avar(--ds-text%2C%23292a2e)%7D%0A._2OUyjtGk8v%7Bbox-shadow%3Avar(--ds-shadow-overlay%2C0%208px%209pt%20%231e1f2126%2C0%200%201px%20%231e1f214f)%7D");





import { type ReactNode } from 'react';
export type TPopoverSurfaceProps = {
  children: ReactNode;
};
const styles = {
  root: "_0bjKvD8fU6 _4bt5LAIZbP _2WAcuGIZbP _0KLXruoI2d _1UtDYzy7kJ _2OUyjtGk8v"
};

/**
 * Optional styled wrapper for popover content.
 *
 * Adds default visual styling (background, border-radius, box-shadow)
 * using design tokens.
 *
 * Presentational primitive - `children`-only by design. This component
 * intentionally exposes no `style`, `className`, `xcss`, `id`, or `ref`
 * props. If you need any of those, render your own wrapper element inside
 * `Popover` instead. `PopoverSurface` is the no-config "give me the default
 * ADS overlay look" surface, nothing more.
 */
export function PopoverSurface({
  children
}: TPopoverSurfaceProps): ReactNode {
  return <div className={ax([styles.root])}>{children}</div>;
}